module.exports = "<div [class.page-sidebar-closed]=\"!sideBarOpen\">\r\n\r\n\t<div class=\"page-container\">\r\n\t\t<div class=\"page-sidebar-wrapper\">\r\n\t\t\t<main-menu></main-menu>\r\n\t\t</div>\r\n\r\n\t\t<div class=\"page-content-wrapper\">\r\n\t\t\t<div class=\"page-content\">\r\n\t\t\t\t<router-outlet></router-outlet>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\r\n\t</div>\r\n\r\n\t<div class=\"page-footer\">\r\n\t\t<div class=\"page-footer-inner\" style=\"float: right;\">\r\n\t\t\t<strong>{{year}} &copy; Pipe Sweden AB. </strong>\r\n\t\t</div>\r\n\t</div>\r\n\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./TypeScript/shell/shell.template.html
// module id = 446
// module chunks = 10